import React from 'react';
import { useTranslation } from 'react-i18next';

type SkeletonProps = {
  ariaLabel?: string;
};

function Skeleton({ ariaLabel = '' }: SkeletonProps): JSX.Element {
  const { t } = useTranslation();
  const accessibleLabel = ariaLabel || t('alt:Loading');

  return (
    <div aria-busy="true" aria-label={accessibleLabel} aria-live="polite" className="skeleton" role="status">
      <div aria-hidden="true" className="skeleton__card">
        <div className="skeleton__block" />
        <div className="skeleton__block skeleton__block--large" />
        <div className="skeleton__block skeleton__block--medium" />
        <div className="skeleton__block skeleton__block--small" />
      </div>
    </div>
  );
}

export default Skeleton;
